
const Account = {
  LogOnOrRegisterForCMS: 'Account/Account.LogOnOrRegisterForCMS',
  LogOnForConnect: 'Account/Account.LogOnForConnect',
  AccountRefreshToken: 'Account/Account.RefreshToken'
}

const Member = {
  MemberCheckOriginalMobilePhone: 'Account/Member.CheckOriginalMobilePhone',
  MemberCheckOriginalEmail: 'Account/Member.CheckOriginalEmail',
  MemberBindPhone: 'Account/Member.BindPhone',
  MemberBindEMail: 'Account/Member.BindEMail',
}

const IndustryTag = {
  QueryAllIndustryTag: 'Account/IndustryTag.QueryAll'
}

const JwtToken = {
  RefreshToken: 'Account/JwtToken.RefreshToken'
}

const Score = {
  CheckIn: 'Account/Score.CheckIn',
  GetScoreLogsByPage: 'Account/Score.GetScoreLogsByPage',
  TodayDidCheckIn: 'Account/Score.TodayDidCheckIn'
}

export default {
  ...Account,
  ...Member,
  ...IndustryTag,
  ...JwtToken,
  ...Score
}